// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ouD3KVbCIAP6iEV6Vwgx{margin-top:32px}.JWo18mmhmgop6X6kz2RI{background:var(--background-error-light);color:var(--action-contained-destructive-primary-normal);border-radius:6px;align-items:center;gap:4px;margin:14px 0;display:flex}.C9n55SiG8nULo8vSWsx1{position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ouD3KVbCIAP6iEV6Vwgx`,
	"warning": `JWo18mmhmgop6X6kz2RI`,
	"gropusLoader": `C9n55SiG8nULo8vSWsx1`
};
export default ___CSS_LOADER_EXPORT___;
